<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb59></breadcrumb59>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>

                <div class="col-md-6 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>

                <div class="col-md-6 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <!-- Basic Information -->
                  <i class="fa fa-arrow-left fa-lg ml-md-4" aria-hidden="true" style="background-color:black; color:white;padding:10px;border-radius:100%; cursor: pointer;" @click="goBack"></i>
                  <div class="col-md-12 mt-2 ml-md-2">
                    <table class="table">
                      <thead>
                        <tr>
                          <th style="background-color: #F8F8F8;" class="text-left column-name">Symptom</th>
                          <!-- <th class="text-left column-description">Description</th> -->
                          <th style="background-color: #F8F8F8;" class="text-left column-action">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in symptoms_count_list" :key="index" v-bind:key="index"
                          v-show="setPaginate(index)">
                          <td class="text-left">
                            {{ symptoms_count_list[index].complaint }}
                          </td>
                          <!-- <td class="text-left">
                              {{ symptoms_count_list[index].description }}
                            </td> -->
                          <td class="text-left">
                            <a href="#graph4" class="btn btn-sm bg-warning-light" data-toggle="modal"
                              @click="editSymptoms(item)">
                              <i class="fas fa-edit"></i> Edit</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <h5 v-if="symptoms_count_list.length === 0 && !showspinner
                      " class="No_data">
                      No Symptom Found
                    </h5>
                    <!-- pagination start -->
                    <div id="pagination" v-if="symptoms_count_list.length > 10">
                      <ul class="pagination justify-content-center">

                        <!-- "Previous" Button -->
                        <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                          <a href="#" class="page-link" aria-label="Previous"
                            @click.prevent="updateSymptomsCount(current - 1)">
                            Previous
                          </a>
                        </li>

                        <!-- Pagination Links (Display 5 at a time) -->
                        <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                          'page-item',
                          current === page_index ? 'active' : ''
                        ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                          <a href="#" class="page-link" @click.prevent="updateSymptomsCount(page_index)">
                            {{ page_index }}
                          </a>
                        </li>

                        <!-- "Next" Button -->
                        <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                          ">
                          <a href="#" class="page-link" aria-label="Next"
                            @click.prevent="updateSymptomsCount(current + 1)">
                            Next
                          </a>
                        </li>
                      </ul>
                    </div>
                    <!-- pagination end -->
                  </div>

                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal fade custom-modal show" id="graph4">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Update Symptoms
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="close()">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Template Name <span class="No_data">*</span></label>
                        <input v-model="symptoms_data.complaint" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '');" />
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Description</label>
                        <textarea id="PatientWording" name="PatientWording" rows="5" cols="50" class="form-control"
                          v-model="symptoms_data.description" value="">
                                </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section" style="text-align:left">
                    <button :disabled="disabled" @click="update_symptoms()" class="btn btn-primary submit-btn"
                      data-dismiss="modal" aria-label="Close">
                      Update Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showspinner: false,
      symptoms_count_list: [],

      symptoms_data: {
        name: "",
        complaint: "",
        description: ""
      },

      current: 1,
      paginate: 10,
      paginate_total: 0,
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {

    close() {
      window.location.reload();
    },

    goBack() {
            // Go one page back
            this.$router.go(-1);
        },
    formatDescription(description) {
      return description.replace(/\n/g, '<br>');
    },
    //pagination start
    updateSymptomsCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end
    editSymptoms(data) {
      (this.editSymptoms = true),
        (this.symptoms_data.name = data.name),
        (this.symptoms_data.complaint = data.complaint),
        (this.symptoms_data.description = data.description)
    },

    /* Add Dependent  */
    async update_symptoms() {
      if (!this.disabled) {
        this.$swal({
          text: "Adding Symptoms...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        // var data = new FormData();
        let data = {
          name: this.symptoms_data.name,
          complaint: this.symptoms_data.complaint,
          description: this.symptoms_data.description
        }


        if (this.editSymptoms) {
          let objIndex = this.symptoms_count_list.findIndex(
            (obj) => obj.name === this.symptoms_data.name
          );
          this.symptoms_count_list[
            objIndex
          ].complaint = this.symptoms_data.complaint;
          this.symptoms_count_list[
            objIndex
          ].description = this.symptoms_data.description;

        } else {
          this.symptoms_count_list.push(this.symptoms_data);
        }
        this.symptoms_count_list = this.symptoms_count_list.map(
          ({ complaint, ...rest }) => ({ ...rest })
        );
        await CommonApi.post_data(
          "sahaj.template.update_my_complaints",
          data
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
            this.get_investigation_advice_templates();
            this.editPrescription = false;
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.symptoms_count_list = [];
          this.symptoms_data.complaint = "";
          this.symptoms_data.description = "";
        });
      }
    },

    //edit exercise plans
    edit_plan_details(id) {
      this.$router.push(`/doctor/edit-exercise-plan/${id}`);
    },
    /* Get All Excercise Plane Details */


    /* Get All Surgery Template Plan  */
    async get_symptoms_count_list() {
      const params = new URLSearchParams();
      params.append("practitioner", this.user_id);
      await CommonApi.get_data(
        "sahaj.api.get_complaints_dr",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.symptoms_count_list = res.data;
          this.paginate_total = Math.ceil(
            this.symptoms_count_list.length / this.paginate
          );
        }
      });
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_symptoms_count_list();
  },
};
</script>

<style scoped>
/* Default column widths */
.column-name {
  min-width: 400px;
}

.column-description {
  min-width: 520px;
}

.column-action {
  min-width: 90px;
}

/* Responsive column widths for smaller screens */
@media (max-width: 768px) {
  .column-name {
    min-width: 250px;
  }

  .column-description {
    min-width: 400px;
  }

  .column-action {
    min-width: 70px;
  }
}

/* Responsive column widths for even smaller screens */
@media (max-width: 480px) {
  .column-name {
    min-width: 150px;
  }

  .column-description {
    min-width: 250px;
  }

  .column-action {
    min-width: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Symptoms.vue